import CustomButton from '../../reusable/CustomButton';
import PrintIcon from '../../assets/print.svg';
import { Transcript, TranscriptPrintData, TranscriptPrintError } from '../../../interfaces/TranscriptsInterface';
import useFetchData from '../../hooks/useFetchData';
import { getTranscriptsDetails } from '../../../services/transcriptsService';
import useSchools from '../../hooks/useSchools';
import TranscriptPrintView from './TranscriptPrintView';
import { getSubjectAreas } from '../../../services/eoaConfigServices';
import PrintContainer from '../../reusable/PrintContainer';

interface TranscriptsPrintContainerProps {
  transcripts: Transcript[];
}

function TranscriptsTablePrintButton({ transcripts }: TranscriptsPrintContainerProps) {
  const { transcriptSelectionSchool } = useSchools();

  const transcriptId = transcripts.length > 0 ? transcripts[0].id : false;

  const { isPending, error, data } = useFetchData({
    fetchData: async (eoaId: string, access_token: string) => {
      let result = await getTranscriptsDetails(eoaId, access_token, transcriptSelectionSchool, transcripts.map(transcript => transcript.id));
      
      const data = [] as Array<TranscriptPrintData | TranscriptPrintError>;

      result.forEach((request, index) => {
        if (request.status === 'fulfilled') {
          data.push({type: 'data', data: request.value.data});
        } else {
          data.push({ studentNumber: transcripts[index].school_student_number, type: 'error' });
        }
      });

      return { data };
    },
    options: {
      dependencies: [transcriptId],
      areDependenciesRequired: true
    },
    errorMessage: 'Error occurred while fetching transcripts details!',
    initialState: []
  });

  const { isPending: isSubjectAreasDataPending, error: subjectAreasDataError, data: subjectAreasData } = useFetchData({
    fetchData: (eoaId, access_token) => getSubjectAreas(access_token),
    errorMessage: 'Error occured while fetching subject areas!',
    initialState: []
  });

  if (error || subjectAreasDataError) return <p>Print unavailable!</p>;

  return (
    <div className="buttons-container">
      <PrintContainer
        printButton={(handlePrint) => (
          <CustomButton
            variant="text"
            buttonText="Print All"
            icon={<img src={PrintIcon} alt="print all"></img>}
            iconPosition="start"
            buttonAction={handlePrint}
            loading={isPending || isSubjectAreasDataPending}
            shouldShowUpdates={true}
          />
        )}
      >
        <>
          { data.map((transcriptDetails, index) => (<TranscriptPrintView key={index} transcript={transcriptDetails} subjectAreas={subjectAreasData} />)) }
        </>
      </PrintContainer>
    </div>
  );
}

export default TranscriptsTablePrintButton;